
export default class OptionItemTyped<T> {

    Id: number | string;
    Text: string;
    Caption: string | undefined;
    Value: T | undefined;

    constructor(id: number | string, name: string, value: T | undefined) {
        this.Id = id;
        this.Text = name;
        this.Value = value;
    }

    static NewInstance() {
        return new OptionItemTyped(0, "", undefined);
    }
}